import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialAdminViewSliceState from './admin-view-initial-state';
import { AdminViewType } from '../../../../shared/enums/adminViewType.enum';
import { Company } from '../models/company.model';
import { Department } from '../models/department.model';
import { Forklift } from '../models/forklift.model';
import { User } from '../models/user.model';
import { Device } from '../models/device.model';
import { Operator } from '../models/operator.model';
import { ForkliftTag } from '../models/tag.model';
import { Organization } from '../models/organization.model';
import { Battery } from '../models/battery.model';
import { Features } from '../models/features.model';
import { MobileTourReq } from '../models/mobileTourReq.model';

const adminViewSlice = createSlice({
    name: 'adminViewSlice',
    initialState: initialAdminViewSliceState,
    reducers: {
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setSelectedCompany(state, { payload }: PayloadAction<string>) {
            state.selectedCompany = payload;
        },
        setSelectedAdminView(state, { payload }: PayloadAction<AdminViewType>) {
            state.selectedView = payload;
        },
        setOrganizationList(state, { payload }: PayloadAction<Organization[]>) {
            state.organizationList = payload;
        },
        setCompanyList(state, { payload }: PayloadAction<Company[]>) {
            state.companyList = payload;
        },
        setDepartmentList(state, { payload }: PayloadAction<Department[]>) {
            state.departmentList = payload;
        },
        setForkliftList(state, { payload }: PayloadAction<Forklift[]>) {
            state.forkliftList = payload;
        },
        setUserList(state, { payload }: PayloadAction<User[]>) {
            state.userList = payload;
        },
        setUserMobileTour(state, { payload }: PayloadAction<{ userId: string } & MobileTourReq>) {
            const user = state.userList.find(x => x.id === payload.userId);
            if (user) {
                user.hasMobileTourDone = payload.hasMobileTourDone;
                user.mobileTourVersion = payload.mobileTourVersion;
            }
        },
        setDeviceList(state, { payload }: PayloadAction<Device[]>) {
            state.deviceList = payload;
        },
        setOperatorList(state, { payload }: PayloadAction<Operator[]>) {
            state.operatorList = payload;
        },
        setTagList(state, { payload }: PayloadAction<ForkliftTag[]>) {
            state.tagList = payload;
        },
        setBatteryList(state, { payload }: PayloadAction<Battery[]>) {
            state.batteryList = payload;
        },
        setFeaturesList(state, { payload }: PayloadAction<Features[]>) {
            state.featuresList = payload;
        }
    }
});

export const {
    setShowFilters,
    setSelectedCompany,
    setSelectedAdminView,
    setOrganizationList,
    setCompanyList,
    setDepartmentList,
    setForkliftList,
    setUserList,
    setUserMobileTour,
    setDeviceList,
    setOperatorList,
    setTagList,
    setBatteryList,
    setFeaturesList
} = adminViewSlice.actions

export default adminViewSlice.reducer